import { render, staticRenderFns } from "./citas.vue?vue&type=template&id=0585bbeb&"
import script from "./citas.vue?vue&type=script&lang=js&"
export * from "./citas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports